// shouldLog and loadedViaCustomer should be able to be removed from all models eventually
import * as Models from "../.";

export interface IEpcCalculationRequest {
    market: Models.CostCalculation.Market.IMarket;
    regionPricingId: number;
    annualProduction: number;
    systemSize: number;
    rate: number;
    monthlyPayment: number;
    calculationStartDate: Date;
    customerReferenceNumber: string;
    partnerSystemNumber: string;
    hasAmendedContract: boolean;
    unshadedPercent: number;
    isSystemDataOverridden: boolean;
    systemDetails?: Models.SystemDetails.SystemDetails.ISystemDetails;
    productCode: string;
    productName: string;
}

export class EpcCalculationRequest implements IEpcCalculationRequest {
    public market: Models.CostCalculation.Market.IMarket;
    public regionPricingId: number;
    public annualProduction = 0;
    public systemSize = 0;
    public rate = 0;
    public monthlyPayment = 0;
    public calculationStartDate: Date;
    public customerReferenceNumber: string;
    public partnerSystemNumber: string;
    public hasAmendedContract: boolean = false;
    public unshadedPercent: number;
    public isSystemDataOverridden: boolean;
    public systemDetails?: Models.SystemDetails.SystemDetails.ISystemDetails;
    public productCode: string;
    public productName: string;
}
